import Notification from '@web/shared-digital-library/vue-components/Global/atoms/Notification.vue';
export default {
  components: {
    Notification: Notification
  },
  data: function data() {
    return {
      displayNotification: false,
      notificationMessage: '',
      notificationType: ''
    };
  },
  created: function created() {
    var _this = this;
    this.$root.$on('notification', function (_ref) {
      var message = _ref.message,
        type = _ref.type;
      _this.displayNotification = true;
      _this.notificationMessage = message;
      _this.notificationType = type;
      window.setTimeout(function () {
        _this.displayNotification = false;
        _this.notificationMessage = '';
        _this.notificationType = '';
      }, 5000);
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.$off('notification');
  }
};